// extracted by mini-css-extract-plugin
export var inline = "_w8-0";